import { Inject, Injectable, InjectionToken } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { AccessibilityConfig } from "../types";

export const ACCESSIBILITY_CONFIG = new InjectionToken<AccessibilityConfig>('accessibilityConfig');

/**
 * We might want to change accessibility configurations in the form.etc in the future according to user
 * preference, this service will help.
 */
@Injectable()
export class AccessibilityService{

    private _configSubject$: BehaviorSubject<AccessibilityConfig> = new BehaviorSubject(this._config);

    constructor(@Inject(ACCESSIBILITY_CONFIG) private _config: AccessibilityConfig){

    }

    /**
     * Set accessibility configurations
     * @param {AccessibilityConfig} config 
     */
    setConfig(config: AccessibilityConfig): void{
        let conf: AccessibilityConfig = {
            focusTab: { 
                ...this._configSubject$.getValue().focusTab, ...config.focusTab 
            }
        };
        
        this._configSubject$.next(conf);
    }

    /**
     * Restore accessibility configurations to default
     */
    restoreDefaults(): void{
        this._configSubject$.next(this._config);
    }

    /**
     * Get the current accessibility configuration
     * @returns acessibility configuration
     */
    getConfig$(): Observable<AccessibilityConfig>{
        return this._configSubject$.asObservable();
    }

}